<template>
    <b-row>
        <b-col 
            v-for="(video, index) in videos" 
            :key="index" 
            cols="6" md="3" class="mb-3 video-item" 
            @click="swVideo(video)">

            <b-img :src="`https://img.youtube.com/vi/${video.ytId}/0.jpg`" fluid></b-img>
            <h3>{{video.title}}</h3>

        </b-col>
    </b-row>
</template>

<script>
export default {
    props: [ 'videos' ],
    data() {
        return {
            
        }
    },
    methods: {
        swVideo(video) {
            this.$emit('swVideo', video)
        }
    },
}
</script>

<style lang="scss">
   
    .video-item {
        color: $color-main-aux;
        cursor: pointer;

        img {
            margin-bottom: 15px
        }
    }
</style>